import { defineMessages } from 'react-intl';

export default defineMessages({
    documentTitle: {
        defaultMessage: 'Sign up',
        description: 'Title of the complete sign up page',
        id: 'cv.complete.sign.up.document.title',
    },
});
